import BlockComponentText from '../../../models/BlockComponentValues/BlockComponentText';
import BlockTableItemData from './BlockTableItemData';
import BlockComponentImage from '../../../models/BlockComponentValues/BlockComponentImage';

export enum BlockTableVariant {
  Default = 'default',
  BorderBottom = 'border-bottom',
  NoBorder = 'no-border',
}

class BlockTableData {
  variant: BlockTableVariant;
  title?: BlockComponentText;
  items?: BlockTableItemData[];
  headerItem?: BlockTableItemData;
  url?: BlockComponentImage;
}

// eslint-disable-next-line @typescript-eslint/no-namespace
namespace BlockTableData {
  export function make(
    variant: BlockTableVariant,
    title?: string,
    items?: BlockTableItemData[],
    headerItem?: BlockTableItemData,
    url?: string,
  ): BlockTableData {
    return {
      variant,
      title: title ? BlockComponentText.make(title) : undefined,
      items,
      headerItem,
      url: BlockComponentImage.make(url),
    };
  }

  export function getDefault(variant = BlockTableVariant.Default, title = '見出し'): BlockTableData {
    return make(
      variant,
      `<p><strong style="font-size: 36px;">${title}</strong></p>`,
      [
        BlockTableItemData.getDefault(),
        BlockTableItemData.getDefault(),
        BlockTableItemData.getDefault(),
      ],
      variant === BlockTableVariant.Default ? BlockTableItemData.getDefault('見出し', '<strong>見出し</strong>') : undefined,
    );
  }
}

export default BlockTableData;
